import React from 'react';
import { useTranslation } from 'react-i18next';
import { Constants } from '@pwc/pwc-deals-web-common';
import { RadioGroup, Select } from '@pwc/pwc-deals-ui';
import PublishButton from '../../../../../common/components/PublishButton';
import { RadioGroupWithSubtitle } from '../../../common/RadioGroupWithSubtitle';
import Form from '../../common/components/Form';
import CheckboxFormikField from '../../../../../common/components/Checkbox/CheckboxFormikField';
import CancelButton from '../../common/components/CancelButtonLink';
import FormBottomActionsContainer from '../../common/components/FormBottomActionsContainer';
import {
  financialMagnitudeOptions,
  financialsDecimalCountOptions,
} from '../../../common/projectOptions.tsx';
import featureFlags from '../../../../../common/helpers/featureFlags';
import './PreferenceStepDisplay.scss';

const PreferenceStepDisplay = ({
  formValues,
  stepOneFormValues,
  isValid = true,
  onChange,
  onCancel,
  onNextClick,
  isSaving,
}) => {
  const { t } = useTranslation();
  const { territory, dealType } = stepOneFormValues;
  const hideForTerritory = ['Canada', 'Brazil'].includes(territory);
  const canShowQuestionnaire =
    !hideForTerritory && featureFlags.diagnostic && dealType === '2';
  return (
    <Form onSubmit={onNextClick} data-testid="project-create-form">
      {canShowQuestionnaire && (
        <>
          {' '}
          <h3>Diagnostic questionnaire</h3>
          <div className="diagnostic-questionnaire">
            The questionnaire is the first step of a divestiture deal’s process
            to create a holistic business overview ahead of a deal. The
            information helps to understand business performance, regulatory
            requirements, and how entangled it is with the rest of the company.{' '}
          </div>
          <CheckboxFormikField
            field={{
              name: 'showDiagnostic',
              value: formValues.showDiagnostic,
              onChange: () =>
                onChange({
                  target: {
                    name: 'showDiagnostic',
                    value: !formValues.showDiagnostic,
                  },
                }),
            }}
            direction="row"
            label="Show Diagnostic Questionnaire"
          />
        </>
      )}
      <div className="step-1-form">
        <h2>{t('formatDetails')}</h2>
        <p className="format-detail-text">{t('automatedStructured')}</p>
        <Select
          basic
          style={{ width: 'calc(var(--s25) * 3)' }}
          options={Constants.CurrencyOptions}
          omitEmpty
          label={t('currancy')}
          onChange={(event) =>
            onChange({
              target: { name: 'currency', value: event.target.value },
            })
          }
          value={formValues.currency}
        />
        <br />
        <RadioGroupWithSubtitle
          label={t('numberFormat')}
          field={{
            name: 'financialsMagnitude',
            value: formValues.financialsMagnitude,
            onChange,
          }}
          options={financialMagnitudeOptions}
          subTitle={t('metricDataMessage')}
        />
        <RadioGroup
          label={t('decimals')}
          field={{
            name: 'financialsDecimalCount',
            value: formValues.financialsDecimalCount,
            onChange,
          }}
          options={financialsDecimalCountOptions}
          direction="column"
        />
      </div>
      <br />
      <div className="separator" />
      <FormBottomActionsContainer>
        <CancelButton onClick={onCancel} />
        <PublishButton
          isSaving={isSaving}
          isValid={isValid}
          buttonSize="sm"
          onSaveText={t('saving')}
          standbyText={t('stdNext')}
          buttonPosition="project-details"
        />
      </FormBottomActionsContainer>
    </Form>
  );
};

export default PreferenceStepDisplay;
